module.exports = __webpack_public_path__ + "img/limozloglicropped.b4abdde3.png";